import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import Drip from 'drip';
import { owlReportError } from '@/utils/monitor-err/index';
import compareVersions from '@/utils/compareVersions';
import KNB from '@dp/knb';
export function getMrnBaseUrl() {
  var _Drip$UA, _Drip$UA2, _Drip$UA3;
  if ((_Drip$UA = Drip.UA) !== null && _Drip$UA !== void 0 && _Drip$UA.IS_MAOYAN) {
    return 'meituanmovie://www.meituan.com/mrn';
  } else if ((_Drip$UA2 = Drip.UA) !== null && _Drip$UA2 !== void 0 && _Drip$UA2.IS_MEITUAN) {
    return 'imeituan://www.meituan.com/mrn';
  } else if ((_Drip$UA3 = Drip.UA) !== null && _Drip$UA3 !== void 0 && _Drip$UA3.IS_DIANPING) {
    return 'dianping://mrn';
  } else {
    return '';
  }
}
export function getTicketLevelMrnPageUrl(paramsStr) {
  var baseURL = getMrnBaseUrl();
  if (!baseURL) return;
  return "".concat(baseURL, "?mrn_biz=maoyanshow&mrn_entry=show-ticket&mrn_component=maoyanshow-ticket&").concat(paramsStr);
}
export function getOrderConfirmMrnPageUrl(paramsStr) {
  var baseURL = getMrnBaseUrl();
  if (!baseURL) return;
  return "".concat(baseURL, "?mrn_biz=maoyanshow&mrn_entry=order-confirm&mrn_component=maoyanshow-order-confirm&").concat(paramsStr);
}
export function isAppSupportMrn() {
  var _Drip$UA4, _Drip$UA5, _Drip$UA6, _Drip$UA7, _Drip$UA8, _Drip$UA9, _Drip$UA10, _Drip$UA11, _Drip$UA12;
  if (!((_Drip$UA4 = Drip.UA) !== null && _Drip$UA4 !== void 0 && _Drip$UA4.IS_MAOYAN) && !((_Drip$UA5 = Drip.UA) !== null && _Drip$UA5 !== void 0 && _Drip$UA5.IS_MEITUAN) && !((_Drip$UA6 = Drip.UA) !== null && _Drip$UA6 !== void 0 && _Drip$UA6.IS_DIANPING)) {
    return false;
  }
  if ((_Drip$UA7 = Drip.UA) !== null && _Drip$UA7 !== void 0 && _Drip$UA7.IS_MEITUAN && !compareVersions((_Drip$UA8 = Drip.UA) === null || _Drip$UA8 === void 0 ? void 0 : _Drip$UA8.appVersion, '11.7.200')) {
    // 美团app 最低mrn3.x版本 11.7.200
    return false;
  }
  if ((_Drip$UA9 = Drip.UA) !== null && _Drip$UA9 !== void 0 && _Drip$UA9.IS_MAOYAN && !compareVersions((_Drip$UA10 = Drip.UA) === null || _Drip$UA10 === void 0 ? void 0 : _Drip$UA10.appVersion, '9.17.0')) {
    // 猫眼app 最低mrn3.x版本 9.17.0
    return false;
  }
  if ((_Drip$UA11 = Drip.UA) !== null && _Drip$UA11 !== void 0 && _Drip$UA11.IS_DIANPING && !compareVersions((_Drip$UA12 = Drip.UA) === null || _Drip$UA12 === void 0 ? void 0 : _Drip$UA12.appVersion, '10.43.0')) {
    // 点评app 最低mrn3.x版本 10.43.0
    return false;
  }
  return true;
}

/**
 * 预加载mrn包
 */
export function preLoadByPageURL() {
  if (!isAppSupportMrn()) return;
  KNB.use('MRN.preLoadByPageURL', {
    params: {
      pageUrl: getTicketLevelMrnPageUrl('')
    },
    success: function success(res) {
      if (res.status !== 'success') {
        owlReportError('', new Error('MRN.preLoadByPageURL: rn_maoyanshow_show-ticket 失败'));
      }
    },
    fail: function fail(e) {
      owlReportError('MRN.preLoadByPageURL: rn_maoyanshow_show-ticket 失败', e);
    }
  });
  KNB.use('MRN.preLoadByPageURL', {
    params: {
      pageUrl: getOrderConfirmMrnPageUrl('')
    },
    success: function success(res) {
      if (res.status !== 'success') {
        owlReportError('', new Error('MRN.preLoadByPageURL: rn_maoyanshow_order-confirm 失败'));
      }
    },
    fail: function fail(e) {
      owlReportError('MRN.preLoadByPageURL: rn_maoyanshow_order-confirm 失败', e);
    }
  });
}

/**
 * 预下载mrn包, 该方法在android 不生效，弃用
 */
export function warmUpByBundleNames() {
  return new Promise(function (resolve) {
    if (!isAppSupportMrn()) {
      resolve(false);
      return;
    }
    KNB.use('MRN.warmUpByBundleNames', {
      params: {
        bundleNames: ['rn_maoyanshow_show-ticket', 'rn_maoyanshow_order-confirm']
      },
      success: function success(result) {
        resolve(true);
      },
      fail: function fail(e) {
        owlReportError('MRN.warmUpByBundleNames 失败', e);
        resolve(false);
      }
    });
  });
}